module.exports = __webpack_public_path__ + "img/fill.0e9a33a3.svg";